export enum BackofficePages {
	Overview = '/backoffice',
	Refund = '/backoffice/refund',
}
